import {useBreakpointUp} from '@travel-frontend/core';
import {memo, useState} from 'react';

import {NewsletterBannerAnniversary} from '@/components/NewsletterBannerAnniversary';
import {NewsletterBannerRegular} from '@/components/NewsletterBannerRegular';
import {config} from '@/config';

type Props = {
  treatment: string;
};

export const NewsletterBanner = memo(function NewsletterBanner({
  treatment,
}: Props) {
  const [open, setOpen] = useState(false);
  const lgUp = useBreakpointUp('lg');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const configPath = config.newsletterBanner?.trackingSource;

  if (!configPath) {
    return null;
  }

  const trackingSource = lgUp ? configPath.desktop : configPath.mobile;
  return (
    <div>
      {treatment === 'anniversary' ? (
        <NewsletterBannerAnniversary
          isDialogOpen={open}
          trackingSource={trackingSource}
          onOpenDialog={handleOpen}
          onCloseDialog={handleClose}
        />
      ) : (
        <NewsletterBannerRegular
          isDialogOpen={open}
          trackingSource={trackingSource}
          onOpenDialog={handleOpen}
          onCloseDialog={handleClose}
        />
      )}
    </div>
  );
});
